import React from 'react';
import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { ChartTooltip } from '../../consts';
import { useThemeMode } from '../theme';
import { Stack, alpha } from '@mui/material';

const WPMChartComponent = ({ data }) => {
    const { colours, FONT } = useThemeMode();

    // when no data in response.
    if (!data.length) {
        return (<Stack fontSize={FONT.SIZE_14} height="100%" alignItems="center" justifyContent="center">
            No Data Available
        </Stack>)
    }

    return (
        <ResponsiveContainer width="100%" height="100%">
            <LineChart
                className="linechart"
                width="100%"
                height="100%"
                data={data}
                margin={{
                    top: 8,
                    right: 0,
                    left: -24,
                    bottom: -8,
                }}
            >
                <CartesianGrid vertical={false} stroke={alpha(colours.black, 0.1)} />
                <XAxis
                    dataKey="name"
                    hide={false}
                    axisLine={{ stroke: alpha(colours.black, 0.1) }}
                    tickLine={{ strokeWidth: 0 }}
                    fontFamily={"'Poppins', sans-serif"}
                    fontSize={FONT.SIZE_12}
                    tick={{
                        fill: colours.black,
                        fontSize: FONT.SIZE_12,
                        fontFamily: "'Poppins', sans-serif",
                    }}
                />
                <YAxis
                    hide={false}
                    type="number"
                    domain={[100, 180]}
                    ticks={[100, 120, 140, 160, 180]}
                    axisLine={{ stroke: alpha(colours.black, 0.1) }}
                    tickLine={{ strokeWidth: 0 }}
                    fontFamily={"'Poppins', sans-serif"}
                    fontSize={FONT.SIZE_12}
                    tick={{
                        fill: colours.black,
                        fontSize: FONT.SIZE_12,
                        fontFamily: "'Poppins', sans-serif",
                    }}
                />
                <Tooltip
                    contentStyle={ChartTooltip(colours, FONT)}
                    itemStyle={{ color: colours.white }}
                />

                <Legend
                    iconType="circle"
                    iconSize={8}
                    wrapperStyle={{
                        fontSize: FONT.SIZE_14,
                        fontWeight: 600,
                        left: 0,
                    }}
                    formatter={(v) => {
                        return v === "Agent"
                            ? `Agent`
                            : `Client`;
                    }}
                />
                <Line
                    type="monotone"
                    dataKey="Agent"
                    stroke={colours.primary100}
                    fill={colours.primary100}
                    dot={false}
                />
                <Line
                    type="monotone"
                    dataKey="Client"
                    stroke={colours.purple100}
                    fill={colours.purple100}
                    dot={false}
                />
            </LineChart>
        </ResponsiveContainer>
    )
}

export default WPMChartComponent